export const enClientPortalNewsFromEinwertWidget = {
    title: 'New from einwert',
    introLineOne: 'Try early versions of our new features before they are integrated into the platform.',
    introLineTwo: 'Share feedback so we can continue improving them.',
    cards: {
        pdfToValXml: {
            title: 'PDF to ValXML',
            text: 'Generate ValXML files from your appraisal PDFs in just a few minutes.',
        },
        autoPlausibility: {
            title: 'Auto plausibility check',
            text: 'Review appraisals with AI-supported standard checks and your own questions.',
        },
        tenantListImport: {
            title: 'Tenant list to Excel',
            text: 'Extract tenant data from Excel or PDF and export it in the einwert format.',
        },
        soonAvailable: {
            title: 'Coming soon',
            text: 'We are continuously improving our beta features and developing more AI tools. Stay tuned.',
        },
    },
    betaLabel: 'Beta',
    tryLabel: 'Explore',
    disclaimer: 'Our tools use AI and do not always deliver accurate results. Please review the results carefully.',
}
